import React from "react";
import MyMapComponent from "./mapMarker";

export default function StateList() {
  const mapData = [
    {
      id: 21,
      vehicle: "SkutKar #21",
      type: "Car",
      battery: 24,
      availability: "available",
      TPMS: "OK",
      DTC: "P3245",
      location: {
        address: {
          city: "City1",
          country: "Country",
          line1: "Addr line 1",
          line2: "Addr line 2",
          postalCode: "13453",
          stateOrProvince: "NY",
        },
        latitude: -34.397,
        longitude: 150.644,
      },
      trackableId: "1657826963564ONP1U4K",
      alerts: [
        {
          dateTime: new Date("2022-08-06 20:12:45.442794").toUTCString(),
          type: "accident",
          typeVal: "Accident",
          value: "",
        },
        {
          dateTime: new Date("2022-07-06 20:12:45.442794").toUTCString(),
          type: "unauthorizedmovement",
          typeVal: "Unauthorized Movement",
          value: "",
        },
        {
          dateTime: new Date("2022-08-05 20:12:45.442794").toUTCString(),
          type: "battery",
          typeVal: "Battery",
          value: "9",
        },
        {
          dateTime: new Date("2022-04-06 20:12:45.442794").toUTCString(),
          type: "tpms",
          typeVal: "TPMS",
          value: "LOW(LF)",
        },
        {
          dateTime: new Date("2022-08-06 20:12:45.442794").toUTCString(),
          type: "accident",
          typeVal: "Accident",
          value: "",
        },
        {
          dateTime: new Date("2022-07-06 20:12:45.442794").toUTCString(),
          type: "unauthorizedmovement",
          typeVal: "Unauthorized Movement",
          value: "",
        },
        {
          dateTime: new Date("2022-08-05 20:12:45.442794").toUTCString(),
          type: "battery",
          typeVal: "Battery",
          value: "9",
        },
        {
          dateTime: new Date("2022-04-06 20:12:45.442794").toUTCString(),
          type: "tpms",
          typeVal: "TPMS",
          value: "LOW(LF)",
        },
      ],
    },
  ];
  return (
    <div style={{ display: "flex", "flex-wrap": "wrap", marginTop: "10px" }}>
      <div style={{ display: "flex", "flex-wrap": "wrap", width: "60%" }}>
        <div style={{ width: "25%" }}>
          <p style={{ margin: "0", fontSize: "12px" }}>State 1</p>
          <p style={{ margin: "0", fontSize: "14px" }}>Lorem Ipsum</p>
        </div>
        <div style={{ width: "25%" }}>
          <p style={{ margin: "0", fontSize: "12px" }}>State 1</p>
          <p style={{ margin: "0", fontSize: "14px" }}>Lorem Ipsum</p>
        </div>
        <div style={{ width: "25%" }}>
          <p style={{ margin: "0", fontSize: "12px" }}>State 1</p>
          <p style={{ margin: "0", fontSize: "14px" }}>Lorem Ipsum</p>
        </div>
        <div style={{ width: "25%" }}>
          <p style={{ margin: "0", fontSize: "12px" }}>State 1</p>
          <p style={{ margin: "0", fontSize: "14px" }}>Lorem Ipsum</p>
        </div>
        <div style={{ width: "25%" }}>
          <p style={{ margin: "0", fontSize: "12px" }}>State 1</p>
          <p style={{ margin: "0", fontSize: "14px" }}>Lorem Ipsum</p>
        </div>
        <div style={{ width: "25%" }}>
          <p style={{ margin: "0", fontSize: "12px" }}>State 1</p>
          <p style={{ margin: "0", fontSize: "14px" }}>Lorem Ipsum</p>
        </div>
        <div style={{ width: "25%" }}>
          <p style={{ margin: "0", fontSize: "12px" }}>State 1</p>
          <p style={{ margin: "0", fontSize: "14px" }}>Lorem Ipsum</p>
        </div>
        <div style={{ width: "25%" }}>
          <p style={{ margin: "0", fontSize: "12px" }}>State 1</p>
          <p style={{ margin: "0", fontSize: "14px" }}>Lorem Ipsum</p>
        </div>
        <div style={{ width: "25%" }}>
          <p style={{ margin: "0", fontSize: "12px" }}>State 1</p>
          <p style={{ margin: "0", fontSize: "14px" }}>Lorem Ipsum</p>
        </div>
        <div style={{ width: "25%" }}>
          <p style={{ margin: "0", fontSize: "12px" }}>State 1</p>
          <p style={{ margin: "0", fontSize: "14px" }}>Lorem Ipsum</p>
        </div>
        <div style={{ width: "25%" }}>
          <p style={{ margin: "0", fontSize: "12px" }}>State 1</p>
          <p style={{ margin: "0", fontSize: "14px" }}>Lorem Ipsum</p>
        </div>
        <div style={{ width: "25%" }}>
          <p style={{ margin: "0", fontSize: "12px" }}>State 1</p>
          <p style={{ margin: "0", fontSize: "14px" }}>Lorem Ipsum</p>
        </div>
      </div>
      <div style={{ "max-height": "320px", overflow: "hidden", width: "40%" }}>
        <MyMapComponent data={mapData} />
      </div>
    </div>
  );
}
